<template>
    <ItemMenuList class="templates-nav__root" :isLoading="isLoading">
        <code>Matched route ==> {{ currentChildRoute }}</code>
        <template slot="Content">
            <b-list-group v-if="dtList!=null && dtList.count > 0">
                <MenuCard v-for="dt in dtList.items" :key="dt.uid" :class="{'router-link-active': currentChildRoute(dt), 'invalid': !dt.isValid}" :menuItem="dt" :href="{name:'DayTemplateDetails', params:{dayTemplateUid: dt.uid}}" @click="onClick(dt)">
                    <template slot="Decorator">
                        <i :class="['fas', dt.isValid ? 'fa-check' : 'fa-minus']" :style="{ color: dt.colorCode }"></i>
                    </template>
                    <template slot="Badge">
                        <!-- showing only for day template below 100% -->
                        <template v-if="Math.round(dt.statistics.fillPercentage) < 100">
                            <span class="badge">{{ Math.round(dt.statistics.fillPercentage) }} %</span>
                        </template>
                    </template>
                </MenuCard>
            </b-list-group>
            <div v-else class="alert alert-info">
                No DT found
            </div>
        </template>
        <template slot="Actions">
            <DayTemplateCreationButton :empty="true" />
        </template>
    </ItemMenuList>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ItemMenuList from'@/components/common/ItemMenuList'
    import MenuCard from'@/components/common/MenuCard'
    import Button from '@/components/common/Button'
    import DayTemplateCreationButton from "./DayTemplateCreationButton"

    export default {
        name: "DayTemplateMenuList",
        components: { ItemMenuList, MenuCard, Button, DayTemplateCreationButton },
        computed: {
            ...mapState({
                isLoading: state => state.loadingStates.isLoadingStationDayTemplates,
                dtList: state => state.stationDayTemplates,
            })
        },
        methods: {
            ...mapActions(['activateDayTemplate']),
            currentChildRoute(elem) {
                return elem.uid === this.$route.params.dayTemplateUid;
            }
            // onClick(dt) {
            //     // need this ? there is an href so this method is never called and action 'activateDayTemplate' doesn't exist...
            //     console.log('dt: ', dt);
            //     //this.activateDayTemplate(dt);
            // }
        }
    }
</script>
<style lang="scss" scoped>
    @import 'global_var';

    .list-group-item {
        background:transparent;
    }
    .fas.fa-check {
        border-radius: 100px;
        background-color: rgba(0,0,0,0.025);
    }

    .templates-nav__root{
        a{
            &.router-link-active{
                border-radius: 3px;
                background: $BGCOLOR_MENU_RADIO_LEFT;
             }
        }
    }
    .badge{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
    }

</style>
